export default {"src":"/_next/static/media/icon_play_tungsten_yourturn.109c68d1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};